import React, { useState } from "react";
import styles from './styles.module.css'
import Title from '../../components/Title'
import TextInput from '../../components/TextInput'
import Button from '../../components/Button'
import ButtonOutline from '../../components/ButtonOutline'
import colors from '../../colors.js'
import PasswordInput from "../../components/PasswordInput";

import { Link, useNavigate } from "react-router-dom";
import { logInWithEmailAndPassword } from "../../firebase";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errMsg, setErrMsg] = useState(false);
  const navigate = useNavigate();

  const handleLogin = () => {
    if (!email || !password) {
      setErrMsg("All fields are required");
      return; 
    }
    logInWithEmailAndPassword(email, password, setErrMsg)
  }

  const handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      handleLogin();
    }
  };

  return (
    <div className={styles.loginContainer}>
        <div className={styles.logoContainer}>
        <img className={styles.logoImg} src='logo.png' alt="RENR logo (leaf)"/>
            <Title>Welcome to RENR Safety App</Title>
        </div>
        <div className={styles.loginForm} onKeyDown={handleKeyDown}>
            <TextInput label={'Email'} setText={setEmail} type='email' name={'email'}/>
            <PasswordInput label={'Password'} setText={setPassword} name={'password'}/>
            {errMsg && <p className={styles.errMsg}>{errMsg}</p>}
            <div className={styles.buttonGroup}>
              <Button color={colors.green} onClick={handleLogin}>Log In</Button>
              <ButtonOutline color={colors.green} onClick={() => navigate('/signup')}>Sign Up</ButtonOutline>
            </div>
            <Link to="/forgot-password" className={styles.forgotPassword}>Forgot your password?</Link>
        </div>
    </div>
  )
}

export default Login